/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetAvailableReportTypes$Params {
}

export function getAvailableReportTypes(http: HttpClient, rootUrl: string, params?: GetAvailableReportTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<'MERCHANTS_WITH_DELIVERY_METHODS' | 'PURCHASE_IN_LAST_30_DAYS' | 'PUBLISHED_PRODUCTS' | 'TENDERS' | 'DISCOUNTS'>>> {
  const rb = new RequestBuilder(rootUrl, getAvailableReportTypes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<'MERCHANTS_WITH_DELIVERY_METHODS' | 'PURCHASE_IN_LAST_30_DAYS' | 'PUBLISHED_PRODUCTS' | 'TENDERS' | 'DISCOUNTS'>>;
    })
  );
}

getAvailableReportTypes.PATH = '/reports';
